import { render, staticRenderFns } from "./RemitaInvoice.vue?vue&type=template&id=3e4385ca&"
import script from "./RemitaInvoice.vue?vue&type=script&lang=js&"
export * from "./RemitaInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports